import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Card, Image, Table, ProgressBar, Button, Form, Modal, Badge, Alert, InputGroup, ListGroup, Collapse} from "react-bootstrap";
import RR34 from "../../../../assets/images/diet/RR34.jpg";
import DEJEUNER from "../../../../assets/images/diet/diner1.png";
import { useDispatch, useSelector } from 'react-redux';
import { GetAllDietPlanByUser, updateRecipeServices } from '../../../../core/store/diet/dietPan/thunk';
import { createSelector } from "@reduxjs/toolkit";
import moment from "moment";
import { Camera, Upload } from 'lucide-react';
import "../../../../css/agenda.css";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

// Configurer le format de date en français
moment.locale('fr');

const DailyNutritionPlan = () => {
  const [plan, setPlan] = useState(null);
  const [todayActivity, setTodayActivity] = useState(null);
  const [selectedMeal, setSelectedMeal] = useState(null);
  const [showChangeModal, setShowChangeModal] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("success");
  const [intolerances, setIntolerances] = useState([]); // État pour gérer les intolérances modifiables
  const [parsedRecipes, setParsedRecipes] = useState([]);
  const [selectedRecipe, setSelectedRecipe] = useState(null);
  const [analysisResult, setAnalysisResult] = useState(null);
  const [showAnalysisModal, setShowAnalysisModal] = useState(false);
  const [aiImage, setAiImage] = useState(null);
  const [showAnalyzeBtn, setShowAnalyzeBtn] = useState(false);
  const [showParcourirBtn, setShowParcourirBtn] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [isScanning, setIsScanning] = useState(false);
  const [showActivities, setShowActivities] = useState(false);
  const [activeTab, setActiveTab] = useState("macro");
  const [isUpdating, setIsUpdating] = useState(false);
  const [expandedInfo, setExpandedInfo] = useState({
    user: false,
    objectives: false,
    calories: false
  });
  const [showMealDetails, setShowMealDetails] = useState(false);
  const [newMealData, setNewMealData] = useState({
    recipeName: "",
    description: "",
    image: null,
    showImageUpload: false,
    allergies: "",
    category: "",
    preparationTime: "",
    cookingTime: "",
    difficulty: "easy"
  });

  const dispatch = useDispatch();

  const selectMealPlanState = (state) => state;
  const mealPlanData = createSelector(
    selectMealPlanState,
    (state) => ({
      error: state.DietPlan.error,
      loading: state.DietPlan.loading,
      mealPlans: state.DietPlan.mealPlans,
    })
  );
  const { error, loading, mealPlans } = useSelector(mealPlanData);
  const navigate = useNavigate();


  const fetchTodayDietPlan = async () => {
    try {
      const userId = JSON.parse(sessionStorage.getItem('authUser'))?.data?.userId;

      if (!userId) {
        console.error('User ID not found in sessionStorage');
        return;
      }

      const result = await dispatch(GetAllDietPlanByUser(userId));
      console.log('Succès IN DAILY NUT:', result.payload);

      const apiData = result.payload?.data || [];
     
      const todayDate = moment().format("YYYY-MM-DD");

      let foundPlan = null;
      let foundMealPlan = null;

      for (const mealPlan of apiData) {
        const match = mealPlan.dailyPlans?.find(plan =>
          moment(plan.dailyDate).format("YYYY-MM-DD") === todayDate
        );
        console.log('today DAILY NUT:', match);
        if (match) {
          foundPlan = match;
          foundMealPlan = mealPlan;
          break;
        }
      }

      if (foundPlan && foundMealPlan) {
        const completePlan = {
          ...foundPlan,
          user: foundMealPlan.user,
          goal: foundMealPlan.goal
        };
        if (foundPlan.dailyMeals && foundPlan.dailyMeals.length > 0) {
          // Évite les doublons dans les catégories
          const seenCategories = {};
          const uniqueMeals = foundPlan.dailyMeals.map(meal => {
            const cat = meal.recipe.category;
            if (seenCategories[cat]) {
              seenCategories[cat] += 1;
              return {
                ...meal,
                recipe: {
                  ...meal.recipe,
                  category: `${cat} ${seenCategories[cat]}` // Ex: "Plat Principal 2"
                }
              };
            } else {
              seenCategories[cat] = 1;
              return meal;
            }
          });
        
          setPlan({
            ...foundPlan,
            dailyMeals: uniqueMeals
          });
        
          setSelectedMeal(uniqueMeals[0]);
        }
        

        setPlan(completePlan);
        setTodayActivity(foundPlan.activities || []);

        if (foundPlan.dailyMeals && foundPlan.dailyMeals.length > 0) {
          setSelectedMeal(foundPlan.dailyMeals[0]);
        }
      } else {
        console.warn("Aucun plan trouvé pour aujourd'hui :", todayDate);
        navigate('/generer-plan');
      }
    } catch (error) {
      console.error('Erreur:', error);
    }
  };

  useEffect(() => {
    fetchTodayDietPlan();
  }, [dispatch, navigate]);




  // useEffect(() => {
  //   const userId = JSON.parse(sessionStorage.getItem('authUser'))?.data?.userId;

  //   if (userId) {
  //     dispatch(GetAllDietPlanByUser(userId))
  //       .then((result) => {
  //         console.log('Succès IN DAILY NUT:', result.payload);
  //         const apiData = result.payload?.data || [];

  //         const todayDate = moment().format("YYYY-MM-DD");

  //         let foundPlan = null;
  //         let foundMealPlan = null;

  //         for (const mealPlan of apiData) {
  //           const match = mealPlan.dailyPlans?.find(plan =>
  //             moment(plan.dailyDate).format("YYYY-MM-DD") === todayDate
  //           );
  //           console.log('today DAILY NUT:', match);
  //           if (match) {
  //             foundPlan = match;
  //             foundMealPlan = mealPlan;
  //             break;
  //           }
  //         }

  //         if (foundPlan && foundMealPlan) {
  //           const completePlan = {
  //             ...foundPlan,
  //             user: foundMealPlan.user,
  //             goal: foundMealPlan.goal
  //           };

  //           setPlan(completePlan);
  //           setTodayActivity(foundPlan.activities || []);

  //           if (foundPlan.dailyMeals && foundPlan.dailyMeals.length > 0) {
  //             setSelectedMeal(foundPlan.dailyMeals[0]);
  //           }
  //         } else {
  //           console.warn("Aucun plan trouvé pour aujourd'hui :", todayDate);
  //           navigate('/generer-plan');
  //         }
  //       })
  //       .catch((error) => {
  //         console.error('Erreur:', error);
  //       });
  //   } else {
  //     console.error('User ID not found in sessionStorage');
  //   }
  // }, [dispatch, navigate]);

  // Fonction pour ouvrir le modal de changement
  const openChangeModal = (meal) => {
    handleShowChangeModal(meal);
  };

  // Fonction pour gérer l'affichage des détails du repas
  const toggleMealDetails = () => {
    setShowMealDetails(!showMealDetails);
  };

  // Fonction pour ouvrir le modal de changement avec les données de la recette sélectionnée
  const handleShowChangeModal = (meal) => {
    setSelectedMeal(meal);
    setNewMealData({
      recipeName: meal?.recipe?.recipeName || "",
      description: meal?.recipe?.description || "",
      showImageUpload: false,
      difficulty: meal.recipe?.difficulty?.toLowerCase() || "easy"
    });
    
    // Initialiser les intolérances existantes
    if (meal?.recipe?.ingredients?.length > 0) {
      const firstIngredient = meal.recipe.ingredients[0];
    
      const existingIntolerances = (firstIngredient.food?.allergens || []).map(allergen => ({
        name: allergen.name || "",
        description: `Intolérance à ${allergen.name}`
      }));
    
      setIntolerances(existingIntolerances);
    } else {
      setIntolerances([]);
    }
    
    // Réinitialisation des états d'image mais en préservant analysisResult
    setImagePreview(null);
    setAiImage(null);
    setShowAnalyzeBtn(false);
    setShowParcourirBtn(false);
    setParsedRecipes([]);
    setSelectedRecipe(null);
    
    // Ne pas réinitialiser analysisResult ici pour conserver l'analyse
    // setAnalysisResult(null); // Cette ligne a été supprimée
  
    setShowChangeModal(true);
  };

  const showToastMessage = (message, type = "success") => {
    setToastMessage(message);
    setToastType(type);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 5000);
  };

  const getUnitForNutrient = (name) => {
    const lower = name.toLowerCase();
    if (lower.includes("vitamine d") || lower.includes("vitamine b12")) return "µg";
    if (lower.includes("vitamine")) return "mg";
    if (lower.includes("sodium") || lower.includes("potassium") || lower.includes("calcium") || lower.includes("magnésium")) return "mg";
    if (lower.includes("fer") || lower.includes("zinc")) return "mg";
    return "mg";
  };

  const macronutrients = [
    { name: "Calories", value: selectedMeal?.recipe?.totalNV?.calories, unit: "kcal" },
    { name: "Protéines", value: selectedMeal?.recipe?.totalNV?.protein, unit: "g" },
    { name: "Glucides", value: selectedMeal?.recipe?.totalNV?.carbs, unit: "g" },
    { name: "Lipides", value: selectedMeal?.recipe?.totalNV?.fats, unit: "g" }
  ].filter(item => item.value > 0);

  const micronutrients = selectedMeal?.recipe?.ingredients?.flatMap(ingredient =>
    ingredient.food?.micronutrients?.map(nutrient => ({
      name: nutrient.name,
      value: nutrient.amount,
      unit: getUnitForNutrient(nutrient.name),
      source: ingredient.ingredientName
    }))
  )?.reduce((acc, curr) => {
    const existing = acc.find(item => item.name === curr.name);
    if (existing) {
      existing.value += curr.value;
    } else {
      acc.push({ ...curr });
    }
    return acc;
  }, []) || [];

  // Renommer la variable pour éviter le conflit avec l'état
  const recipeIntolerances =
  selectedMeal?.recipe?.ingredients?.[0]?.food?.allergens?.map(allergen => ({
    name: allergen.name,
    type: allergen.type,
    ingredient: selectedMeal.recipe.ingredients[0].ingredientName
  })) || [];


  console.log("recipeIntolerances:", recipeIntolerances);
  const totalCalories = plan?.dailyMeals?.reduce((sum, meal) => sum + (meal.recipe?.totalNV?.calories || 0), 0) || 0;
  const consumedCalories = plan?.dailyMeals
    ?.filter((meal) => meal.consumed)
    .reduce((sum, meal) => sum + (meal.recipe?.totalNV?.calories || 0), 0) || 0;
  const remainingCalories = totalCalories - consumedCalories;
  const progress = totalCalories > 0 ? Math.round((consumedCalories / totalCalories) * 100) : 0;

  const detailsRef = useRef(null);

  async function listModels() {
    const API_KEY = "AIzaSyCRgL3AS1Kl8QEhs1LPrrelMA5fRHlE_pA";
    const response = await fetch(
      `https://generativelanguage.googleapis.com/v1/models?key=${API_KEY}`
    );
    const models = await response.json();
    console.log("models",models);
  }
  useEffect(() => {
    listModels();
    if (selectedRecipe && detailsRef.current) {
      requestAnimationFrame(() => {
        setTimeout(() => {
          detailsRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      });
    }
  }, [selectedRecipe]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        setImagePreview(event.target.result);
        // Activer les boutons après le chargement de l'image
        setShowAnalyzeBtn(true);
        setShowParcourirBtn(true);
      };
      reader.readAsDataURL(file);
      
      setNewMealData({
        ...newMealData,
        image: file
      });
    }
  };

  function toBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  async function analyzeImageWithGemini(imageFile) {

    
    setIsScanning(true);
  
    const API_KEY = "AIzaSyCRgL3AS1Kl8QEhs1LPrrelMA5fRHlE_pA"; // ⚠️ Mets ta clé ici
    const API_URL = `https://generativelanguage.googleapis.com/v1/models/gemini-2.5-flash:generateContent?key=${API_KEY}`;
  
    const imageBase64 = await toBase64(imageFile);
  
    const prompt = `
  Tu es un chef cuisinier et un assistant en nutrition intelligent.
  Voici une image contenant plusieurs aliments visibles.
  Ta mission est :
  
  1. D'identifier précisément tous les aliments visibles sur l'image.
  2. De proposer exactement 8 recettes concrètes, équilibrées, réalistes et variées.
  3. Pour chaque recette, retourne un objet au format suivant :
  
  {
    "nom": "Nom de la recette",
    "ingrédients": "Liste complète des ingrédients visibles ou issus de l'image",
    "description": "Courte description du plat",
    "complementIngredients": "Petits ingrédients courants (comme huile, sel, ail, oignon, épices, herbes) nécessaires mais absents sur l'image",
    "tempsPreparation": "Durée approximative en minutes (ex: 30 min)",
    "image": "Description courte ou URL d'image générée"
  }
  
  ⚠️ Les recettes doivent uniquement utiliser les ingrédients visibles sur l'image + des compléments simples.
  ⚠️ Ne propose jamais plus de 8 recettes.
  ⚠️ Fournis toutes les recettes sous forme de tableau JSON d'objets, sans explication autour.
  `.trim();
  
    const requestBody = {
      contents: [
        {
          parts: [
            { text: prompt },
            {
              inlineData: {
                mimeType: imageFile.type,
                data: imageBase64.split(",")[1],
              },
            },
          ],
        },
      ],
    };
  
    try {
      const response = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });
  
      const result = await response.json();
  
      if (!response.ok) {
        console.error("Erreur Gemini:", result);
        throw new Error(result.error?.message || "Erreur lors de l'analyse de l'image");
      }
  
      const analysisText = result.candidates?.[0]?.content?.parts?.[0]?.text || "";
      let recipes = [];
      setIsScanning(false);
  
      try {
        let cleanText = analysisText.trim();
        if (cleanText.startsWith("```json")) {
          cleanText = cleanText.replace(/^```json/, "").replace(/```$/, "").trim();
        }
        recipes = JSON.parse(cleanText).map((r, index) => ({
          id: index,
          title: r.nom,
          description: r.description,
          ingredients: r.ingrédients.split(",").map((i) => i.trim()),
          instructions: [
            `Préparez les ingrédients : ${r.ingrédients}.`,
            `Ajoutez les compléments : ${r.complementIngredients}.`,
            "Cuisinez selon votre goût !",
          ],
          difficulty: "Facile",
          time: r.tempsPreparation || "30 min",
          image: r.image?.startsWith("http")
            ? r.image
            : `/api/placeholder/300/200?text=${encodeURIComponent(r.nom)}`,
        }));
      } catch (err) {
        console.warn("Impossible de parser le JSON :", err.message);
        console.warn("Texte brut renvoyé :", analysisText);
      }
  
      if (!Array.isArray(recipes) || recipes.length !== 8) {
        console.warn("Résultat inattendu. Voici le texte brut :", analysisText);
      }
  
      setAnalysisResult(analysisText);
      setParsedRecipes(recipes);
      setShowAnalysisModal(true);
      setShowAnalyzeBtn(false);
      setShowParcourirBtn(true);
  
      return result;
    } catch (error) {
      console.error("Erreur dans analyzeImageWithGemini :", error.message);
      setAnalysisResult("Une erreur s'est produite pendant l'analyse.");
      setParsedRecipes([]);
      setShowAnalysisModal(true);
      setIsScanning(false);
      return null;
    }
  }
  

  // Fonction pour mettre à jour une recette via l'API
  const updateRecipe = async (recipeData) => {
    try {
      setIsUpdating(true);
  
      const user = JSON.parse(sessionStorage.getItem("authUser"))?.data;
      const userId = user?.userId;
      const recipeId = selectedMeal?.recipe?.id || selectedMeal?.id;
  
      // Créer le tableau updateData avec les données du plat
      const updateData = [
        {
          type: "ALIMENTARY",
          name: recipeData.name || selectedMeal?.recipe?.name || "",
          description: recipeData.description || selectedMeal?.recipe?.description || "",
        }
      ];

      // Ajouter les intolérances modifiées
      if (intolerances && intolerances.length > 0) {
        intolerances.forEach(intolerance => {
          if (intolerance?.name && intolerance?.name.trim() !== '') {
            updateData.push({
              type: "INTOLERANCE",
              name: intolerance?.name.trim(),
              description: intolerance.description || `Intolérance à ${intolerance?.name.trim()}`
            });
          }
        });
      }
  
      console.log("Données envoyées:", updateData);
  
      await dispatch(
        updateRecipeServices({ updateData, recipeId, userId })
      ).unwrap();
  
      showToastMessage("Recette mise à jour avec succès!", "success");
      setShowChangeModal(false);
  
      // Réinitialiser les états
      setImagePreview(null);
      setAiImage(null);
      setParsedRecipes([]);
      setSelectedRecipe(null);
      setIntolerances([]); // Réinitialiser les intolérances
      fetchTodayDietPlan();
    } catch (error) {
      console.error("Erreur lors de la mise à jour:", error);
      let errorMessage = "Une erreur s'est produite lors de la mise à jour.";
      if (error?.status === 401) errorMessage = "Session expirée. Veuillez vous reconnecter.";
      else if (error?.status === 404) errorMessage = "Recette introuvable.";
      else if (error?.message) errorMessage = error.message;
  
      showToastMessage(errorMessage, "danger");
    } finally {
      setIsUpdating(false);
    }
  }
    

  const handleSubmitNewMeal = () => {
    // Validation des champs requis
    if (!newMealData?.recipeName?.trim()) {
      showToastMessage("Le nom du plat est requis.", "warning");
      return;
    }

    // Préparer les données finales
    let finalData = {
      name: newMealData?.recipeName?.trim(),
      description: newMealData?.description.trim()
    };

    // Si une recette IA a été sélectionnée, utiliser ses données
    if (selectedRecipe) {
      finalData = {
        name: selectedRecipe.title,
        description: selectedRecipe.description
      };
    }

    // Appeler l'API de mise à jour
    updateRecipe(finalData);
  };

  const [iaResult, setIaResult] = useState('');

  return (
    <>
      {loading && <p>🔍 Analyse de l'image en cours…</p>}

      {iaResult && (
        <div className="mt-3 p-3 border rounded bg-light">
          <h5>📋 Résultat de l'analyse :</h5>
          <div dangerouslySetInnerHTML={{ __html: iaResult.replace(/\n/g, "<br>") }} />
        </div>
      )}

      {showToast && (
        <div className="position-fixed top-0 end-0 p-3" style={{ zIndex: 1050 }}>
          <Alert 
            variant={toastType} 
            onClose={() => setShowToast(false)} 
            dismissible
            className="shadow-lg"
          >
            {toastMessage}
          </Alert>
        </div>
      )}
  
      <div style={{marginTop:"-30px"}} className="top-0  p-1">
        {/* Card d'information principale */}
        <Card className="mb-2 shadow">
          <Card.Body>
            <div className="d-flex justify-content-between align-items-center mb-2">
              <div>
                <p className="text-primary mb-0 fw-bold">
                  {moment().format("dddd D MMMM YYYY")} - {plan?.status === "ACTIVE" ? "Plan en cours" : "Plan initialisé"}
                </p>
              </div>
              <div style={{ width: "60%" }}>
                <ProgressBar style={{ height: '20px', backgroundColor: "#f8f9fa" }}>
                  <ProgressBar
                    now={progress}
                    label={`${progress}%`}
                    animated
                    variant="primary"
                  />
                  <ProgressBar
                    now={100 - progress}
                    label={`${remainingCalories} kcal restantes`}
                    style={{ backgroundColor: "#dee2e6", color: "#000" }}
                  />
                </ProgressBar>
              </div>
            </div>

            <Row className="g-4">
              {/* Informations utilisateur */}
              <Col md={4}>
                <div 
                  className="d-flex align-items-center gap-2 mb-2 cursor-pointer"
                  onClick={() => setExpandedInfo({ ...expandedInfo, user: !expandedInfo.user })}
                >
                  <h5 className="mb-0">📅 Plan du jour</h5>
                  <i className={`bi bi-chevron-${expandedInfo.user ? 'up' : 'down'} ms-auto`}></i>
                </div>
                <div className="mb-2">
                  <span>Status : </span>
                  <Badge bg={plan?.status === "ACTIVE" ? "success" : "secondary"}>
                    {plan?.status === "ACTIVE" ? "Actif" : plan?.status === "INITIATED" ? "Initialisé" : plan?.status}
                  </Badge>
                </div>
                <Collapse in={expandedInfo.user}>
                  <div>
                    <hr className="my-2" />
                    <p className="mb-1 small">Dernière mise à jour : {moment(plan?.updatedAt).format("DD/MM/YYYY HH:mm")}</p>
                  </div>
                </Collapse>
              </Col>
              
              {/* Objectifs */}
              <Col md={4}>
                <div 
                  className="d-flex align-items-center gap-2 mb-2 cursor-pointer"
                  onClick={() => setExpandedInfo({ ...expandedInfo, objectives: !expandedInfo.objectives })}
                >
                  <h5 className="mb-0">🎯 Objectifs</h5>
                  <i className={`bi bi-chevron-${expandedInfo.objectives ? 'up' : 'down'} ms-auto`}></i>
                </div>
                <div className="mb-1">
                  <Badge bg="primary" className="me-2">{plan?.goal || "Non spécifié"} WEIGHT </Badge>
                  <span className="text-muted">•</span>
                  <span className="ms-2">{plan?.user?.weight} kg → {plan?.user?.userGoal?.weightGoal?.targetWeight} kg</span>
                </div>
                <Collapse in={expandedInfo.objectives}>
                  <div>
                    <hr className="my-2" />
                    <p className="small text-muted mt-2">
                      {plan?.user?.weight > plan?.user?.userGoal?.weightGoal?.targetWeight ? 
                        "Objectif de poids" : "Objectif de poids"}
                    </p>
                  </div>
                </Collapse>
              </Col>
              
              {/* Calories et macros */}
              <Col md={4}>
                <div 
                  className="d-flex align-items-center gap-2 mb-2 cursor-pointer"
                  onClick={() => setExpandedInfo({ ...expandedInfo, calories: !expandedInfo.calories })}
                >
                  <h5 className="mb-0">🔥 Calories & Macros</h5>
                  <i className={`bi bi-chevron-${expandedInfo.calories ? 'up' : 'down'} ms-auto`}></i>
                </div>
                <div className="mb-1">
                  <Badge bg="info" className="me-2">{plan?.dailyGoal?.calories} kcal</Badge>
                  <span className="small text-muted">cible journalière</span>
                </div>
                <Collapse in={expandedInfo.calories}>
                  <div>
                    <hr className="my-2" />
                    <div className="d-flex justify-content-between">
                      <div className="text-center">
                        <div className="fw-bold text-primary">{plan?.dailyGoal?.protein}g</div>
                        <small className="text-muted">Protéines</small>
                      </div>
                      <div className="text-center">
                        <div className="fw-bold text-success">{plan?.dailyGoal?.carbs}g</div>
                        <small className="text-muted">Glucides</small>
                      </div>
                      <div className="text-center">
                        <div className="fw-bold text-warning">{plan?.dailyGoal?.fats}g</div>
                        <small className="text-muted">Lipides</small>
                      </div>
                    </div>
                  </div>
                </Collapse>
              </Col>
            </Row>
          </Card.Body>
        </Card>
  
        <div>
          <Row>
            <Col lg={12}>
              {/* Détails du repas sélectionné */}
              {selectedMeal && (
                <Card
                  className="shadow mb-4"
                  style={{ overflow: 'auto', maxHeight: '70vh', zIndex: 1 }}
                >
                   <Card.Header className="bg-light sticky-top p-2">
                    <div className="d-flex flex-wrap align-items-center gap-3">
                      <div className="d-flex flex-wrap align-items-center gap-3 overflow-auto">
                        {plan?.dailyMeals?.length > 0 && Array.from(
                          new Set(
                            plan.dailyMeals
                              .map(meal => meal.recipe?.category)
                              .filter(category => category)
                          )
                        ).map(category => {
                          const categoryIcon =
                            category.toLowerCase().includes('petit') || category.toLowerCase().includes('breakfast') ? '🍳' :
                            category.toLowerCase().includes('collation') || category.toLowerCase().includes('snack') ? '🥜' :
                            category.toLowerCase().includes('déjeuner') || category.toLowerCase().includes('lunch') ? '🍽️' :
                            category.toLowerCase().includes('dîner') || category.toLowerCase().includes('dinner') ? '🌙' :
                            '🍽️';

                          const mealsInCategory = plan.dailyMeals.filter(
                            meal => meal.recipe?.category === category
                          );

                          const categoryCalories = mealsInCategory.reduce(
                            (sum, meal) => sum + (meal.recipe?.totalNV?.calories || 0),
                            0
                          );

                          const isSelected = selectedMeal && mealsInCategory.some(meal => meal.id === selectedMeal.id);

                          return (
                            <div 
                              key={category} 
                              className="d-flex align-items-center border rounded shadow-sm px-3 py-2"
                              style={{ width: '280px', cursor: 'pointer', borderColor: '#C0C0C0' }}
                              onClick={() => {
                                if (!isSelected) {
                                  setSelectedMeal(mealsInCategory[0]);
                                }
                              }}
                            >
                              <div className="d-flex align-items-center justify-content-center bg-light rounded" style={{ width: '60px', height: '100%', fontSize: '1.8rem' }}>
                                <span>{categoryIcon}</span>
                              </div>

                              <div className="ms-3 d-flex flex-column justify-content-center w-100">
                                <div className={`fw-bold ${isSelected ? 'text-primary' : 'text-dark'}`} style={{ fontSize: '1.1rem' }}>
                                  {category}
                                </div>

                                <div className="text-muted small d-flex align-items-center gap-2">
                                  {categoryCalories} kcal
                                  {mealsInCategory.some(meal => meal.consumed) && (
                                    <Badge bg="success" pill className="align-self-start" style={{ fontSize: '0.85rem' }}>
                                      ✅
                                    </Badge>
                                  )}
                                </div>

                                {mealsInCategory.some(meal => !meal.consumed) && (
                                  <Badge
                                    bg="warning"
                                    pill
                                    className="mt-1 align-self-start"
                                    style={{ fontSize: '1rem', padding: '6px 12px', fontWeight: 500 }}
                                  >
                                    🍽️ À consommer
                                  </Badge>
                                )}
                              </div>
                            </div>
                          );
                        })}

                        <Button
                          variant="bg-light"
                          onClick={() => setShowActivities(prev => !prev)}
                          className="d-flex align-items-center justify-content-center border rounded px-3 py-2"
                          style={{
                            height: '6rem',
                            fontWeight: 'bold',
                            borderColor: showActivities ? '#C0C0CC' : '#198754',
                            color: showActivities ? '#26b4cb' : '#5cc537',
                            minWidth: '250px',
                            whiteSpace: 'nowrap'
                          }}
                        >
                          <i className={`bi ${showActivities ? 'bi-eye-slash' : 'bi-eye'} me-2`}></i>
                          {showActivities ? 'Masquer les activités' : 'Afficher les activités'}
                        </Button>
                      </div>
                    </div>
                  </Card.Header>

                  <Card.Body>
                    <Row>
                      {/* Colonne image */}
                      <Col lg={5}>
                        <div className="position-relative mb-3">
                          <div 
                            style={{
                              width: '100%',
                              height: selectedMeal && !selectedMeal.consumed ? '340px' : '390px',
                              overflow: 'hidden',
                              borderRadius: '0.5rem',
                              transition: 'height 0.3s ease'
                            }}
                          >
                            <Image 
                              src={DEJEUNER} 
                              alt={selectedMeal?.recipe?.name} 
                              style={{ 
                                width: '100%', 
                                height: '100%', 
                                objectFit: 'cover', 
                                display: 'block' 
                              }} 
                            />
                          </div>

                          <div className="position-absolute top-0 end-0 p-2">
                            <Badge bg="dark">{selectedMeal?.recipe?.category}</Badge>
                          </div>
                        </div>

                        {selectedMeal && !selectedMeal.consumed && (
                          <div className="d-flex justify-content-center align-items-center">
                            <Button
                              variant="warning"
                              onClick={() => openChangeModal(selectedMeal)}
                              style={{ width: '40%' }}
                              className="mt-3"
                            >
                              <div className="d-flex justify-content-center align-items-center">
                                <i className="bi bi-arrow-repeat me-2"></i>
                                Changer ce plat
                              </div>
                            </Button>
                          </div>
                        )}
                      </Col>

                      {/* Colonne description repas */}
                      <Col lg={showActivities ? 4 : 7}>
                        <h4>{selectedMeal?.recipe?.recipeName || selectedMeal?.recipe?.name}</h4>
                        <p className="text-muted">{selectedMeal?.recipe?.description}</p>

                        <div className="d-flex flex-wrap gap-2 mb-3">
                          <Badge bg="secondary" className="px-2 py-1">
                            <i className="bi bi-speedometer2 me-1"></i>
                            {selectedMeal?.recipe?.difficulty || "Non spécifiée"}
                          </Badge>
                          <Badge bg="secondary" className="px-2 py-1">
                            <i className="bi bi-clock me-1"></i>
                            {selectedMeal?.recipe?.preparationTime || "N/A"} min
                          </Badge>
                        </div>

                        <div>
                          {/* Boutons d'onglets */}
                          <Row className="mb-3">
                            <Col className="d-flex justify-content-center gap-2 flex-nowrap">
                              <Button
                                className="truncate-btn"
                                variant={activeTab === "macro" ? "success" : "outline-success"}
                                onClick={() => setActiveTab("macro")}
                              >
                                Macronutriments
                              </Button>
                              <Button
                                className="truncate-btn"
                                variant={activeTab === "micro" ? "primary" : "outline-primary"}
                                onClick={() => setActiveTab("micro")}
                              >
                                Micronutriments
                              </Button>
                              <Button
                                className="truncate-btn"
                                variant={activeTab === "intolerance" ? "danger" : "outline-danger"}
                                onClick={() => setActiveTab("intolerance")}
                              >
                                Intolérances
                              </Button>
                            </Col>
                          </Row>

                          {/* Tableaux selon l'onglet actif */}
                          <div className="table-responsive">
                            <Table striped bordered hover size="sm">
                              <thead className="table-light">
                                <tr>
                                  <th>Type</th>
                                  <th>Valeur</th>
                                </tr>
                              </thead>
                              <tbody>
                                {activeTab === "macro" &&
                                  macronutrients.map((item) => (
                                    <tr key={item.name}>
                                      <td><strong>{item.name}</strong></td>
                                      <td><strong>{item.value} {item.unit}</strong></td>
                                    </tr>
                                  ))
                                }

                                {activeTab === "micro" &&
                                  micronutrients.map((nutrient, index) => (
                                    <tr key={`${nutrient.name}-${index}`}>
                                      <td>{nutrient.name}</td>
                                      <td>{nutrient.value.toFixed(1)} {nutrient.unit}</td>
                                    </tr>
                                  ))
                                }

                                {activeTab === "intolerance" &&
                                  (recipeIntolerances.length > 0 ? recipeIntolerances.map((item, idx) => (
                                    <tr key={idx}>
                                      <td>{item.name}</td>
                                      <td>Présent dans <strong>{item.ingredient}</strong></td>
                                    </tr>
                                  )) : (
                                    <tr>
                                      <td colSpan={2} className="text-center">Aucune intolérance détectée ✅</td>
                                    </tr>
                                  ))
                                }
                              </tbody>
                            </Table>
                          </div>
                        </div>
                      </Col>

                      {/* Colonne Activités */}
                      {showActivities && todayActivity && todayActivity.length > 0 && (
                        <Col lg={3} style={{ maxHeight: '100vh', overflowY: 'auto' }}>
                          <div className="bg-white rounded shadow p-3" style={{ position: 'sticky', top: '20px' }}>
                            <h5 className="text-primary mb-3">🏋️ Activités du jour</h5>

                            {todayActivity.map((entry, i) => (
                              <div
                                key={i}
                                className="mb-3 p-3 border-start border-4 border-info bg-light rounded position-relative"
                              >
                                <div className="d-flex justify-content-between align-items-center">
                                  <h6 className="text-info fw-bold mb-1">{entry.activity?.name || "Activité"}</h6>
                                  <span className="badge bg-primary-subtle text-primary fw-semibold">
                                    {entry.duration} min
                                  </span>
                                </div>
                                <div className="text-muted small">
                                  <i className="bi bi-calendar me-1"></i> {moment(entry.date).format("DD MMM YYYY")}
                                </div>
                              </div>
                            ))}
                          </div>
                        </Col>
                      )}
                    </Row>
                  </Card.Body>
                </Card>
              )}
            </Col>
          </Row>
        </div>
  
        {/* Modal changer de plat - VERSION COMPLÈTE MISE À JOUR */}
        <Modal show={showChangeModal} onHide={() => setShowChangeModal(false)} centered size="lg">
          <Modal.Header closeButton>
            <Modal.Title>🔄 Changer le plat : {selectedMeal?.recipe?.recipeName || selectedMeal?.recipe?.name}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-bold">🍽️ Nom du plat</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Ex: Poulet grillé aux légumes"
                        value={newMealData.recipeName || ""}
                        onChange={(e) => setNewMealData({ ...newMealData, recipeName: e.target.value })}
                      />

                  </Form.Group>
                </Col>
               
              </Row>
  
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold">📝 Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Décris brièvement ton plat..."
                  value={newMealData.description}
                  onChange={(e) => setNewMealData({ ...newMealData, description: e.target.value })}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Check
                  type="switch"
                  label="📸 Je souhaite charger une image pour obtenir des suggestions"
                  checked={newMealData.showImageUpload}
                  onChange={(e) => setNewMealData({
                    ...newMealData,
                    showImageUpload: e.target.checked
                  })}
                />
              </Form.Group>

              {/* Section des intolérances */}
              <Form.Group className="mb-3">
                 <Form.Label className="fw-bold">🚫 Intolérances alimentaires</Form.Label>
                  {intolerances.map((intolerance, index) => ( <div key={index} className="d-flex align-items-center mb-2">
                    
                 <Form.Control type="text" placeholder="Nom de l'intolérance" value={intolerance.name} onChange={(e) => { const newIntolerances = [...intolerances]; newIntolerances[index].name = e.target.value; setIntolerances(newIntolerances); }} className="me-2" />
                   <Button variant="outline-danger" size="sm" 
                    onClick={() => { const newIntolerances = intolerances.filter((_, i) => i !== index);
                    setIntolerances(newIntolerances); }} >
                     Supprimer
                   </Button> </div> ))}
                   
                   <Button variant="outline-primary" size="sm"
                    onClick={() => setIntolerances([...intolerances, { name: "", description: "" }])} className="mt-2" >
                       + Ajouter une intolérance
                   </Button>
             </Form.Group>


              {newMealData.showImageUpload && (
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">📷 Image du plat</Form.Label>

                  <div className="border rounded p-3" style={{ backgroundColor: '#f8f9fa' }}>
                    <Row className="justify-content-center">
                      {/* Image chargée manuellement */}
                      {imagePreview && (
                        <Col md={aiImage ? 6 : 8} className="text-center mb-3">
                          <div className="position-relative d-inline-block">
                            <div className="scanning-container" style={{ position: 'relative', display: 'inline-block' }}>
                              <Image
                                src={imagePreview}
                                alt="Image chargée"
                                fluid
                                rounded
                                style={{ maxHeight: '200px' }}
                                className={isScanning ? "scanning-image" : ""}
                              />
                              
                              {/* Effet de scan */}
        {isScanning && (
          <>
            {/* Lignes de scan horizontales multiples */}
            <div 
              className="scan-line primary" 
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '3px',
                background: 'rgba(0, 255, 128, 0.7)',
                boxShadow: '0 0 10px rgba(0, 255, 128, 0.9), 0 0 20px rgba(0, 255, 128, 0.5)',
                animation: 'scanAnimation 2s linear infinite',
                zIndex: 2
              }}
            />
            <div 
              className="scan-line secondary" 
              style={{
                position: 'absolute',
                top: '30%',
                left: 0,
                width: '100%',
                height: '2px',
                background: 'rgba(0, 200, 255, 0.6)',
                boxShadow: '0 0 8px rgba(0, 200, 255, 0.8)',
                animation: 'scanAnimation 2.7s linear infinite',
                zIndex: 2
              }}
            />
            
            {/* Ligne de scan verticale */}
            <div 
              className="scan-line vertical" 
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '2px',
                height: '100%',
                background: 'rgba(255, 0, 128, 0.6)',
                boxShadow: '0 0 8px rgba(255, 0, 128, 0.8)',
                animation: 'scanAnimationHorizontal 3.2s linear infinite',
                zIndex: 2
              }}
            />
            
            {/* Superposition d'analyse */}
            <div 
              className="scan-overlay" 
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                background: 'rgba(0, 40, 80, 0.15)',
                border: '1px solid rgba(0, 200, 255, 0.5)',
                borderRadius: '0.25rem',
                backdropFilter: 'brightness(1.05) contrast(1.05)',
                zIndex: 1
              }}
            />
            
            {/* Coins technologiques */}
            <div className="scan-corners">
              {['top-left', 'top-right', 'bottom-left', 'bottom-right'].map(corner => (
                <div 
                  key={corner}
                  className={`scan-corner ${corner}`}
                  style={{
                    position: 'absolute',
                    width: '25px',
                    height: '25px',
                    borderColor: 'rgba(0, 255, 255, 0.8)',
                    borderStyle: 'solid',
                    ...(corner === 'top-left' ? {
                      top: '5px',
                      left: '5px',
                      borderWidth: '2px 0 0 2px',
                      animation: 'cornerPulse 2s infinite'
                    } : corner === 'top-right' ? {
                      top: '5px',
                      right: '5px',
                      borderWidth: '2px 2px 0 0',
                      animation: 'cornerPulse 2s infinite 0.5s'
                    } : corner === 'bottom-left' ? {
                      bottom: '5px',
                      left: '5px',
                      borderWidth: '0 0 2px 2px',
                      animation: 'cornerPulse 2s infinite 1s'
                    } : {
                      bottom: '5px',
                      right: '5px',
                      borderWidth: '0 2px 2px 0',
                      animation: 'cornerPulse 2s infinite 1.5s'
                    })
                  }}
                />
              ))}
            </div>
            
            {/* Points de mesure/détection */}
            {Array.from({ length: 8 }).map((_, index) => {
              const randomX = Math.floor(Math.random() * 80) + 10; // 10% to 90%
              const randomY = Math.floor(Math.random() * 80) + 10; // 10% to 90%
              return (
                <div 
                  key={`point-${index}`}
                  className="detection-point"
                  style={{
                    position: 'absolute',
                    width: '6px',
                    height: '6px',
                    borderRadius: '50%',
                    backgroundColor: index % 2 === 0 ? 'rgba(255, 0, 128, 0.7)' : 'rgba(0, 255, 128, 0.7)',
                    boxShadow: index % 2 === 0 ? '0 0 5px rgba(255, 0, 128, 0.9)' : '0 0 5px rgba(0, 255, 128, 0.9)',
                    top: `${randomY}%`,
                    left: `${randomX}%`,
                    animation: `pointPulse 1.5s infinite ${index * 0.2}s`,
                    zIndex: 3
                  }}
                />
              );
            })}
            
            {/* Interface HUD */}
            <div 
              className="scan-hud"
              style={{
                position: 'absolute',
                top: '5px',
                right: '30px',
                color: 'rgba(0, 255, 255, 0.9)',
                fontSize: '8px',
                fontFamily: 'monospace',
                textAlign: 'right',
                textShadow: '0 0 2px rgba(0, 255, 255, 0.8)',
                zIndex: 3
              }}
            >
              <div className="hud-line">SCAN: en cour...</div>
              <div className="hud-line">RÉS: ÉLEVÉE</div>
              <div className="hud-line">DÉTECTION: ACTIVE</div>
            </div>
            
            {/* Texte d'analyse avancé */}
            <div 
              className="scan-text"
              style={{
                position: 'absolute',
                bottom: '10px',
                left: '50%',
                transform: 'translateX(-50%)',
                color: 'cyan',
                fontSize: '10px',
                fontFamily: 'monospace',
                textShadow: '0 0 2px rgba(0, 255, 255, 0.8)',
                zIndex: 3,
                animation: 'textBlink 1s infinite'
              }}
            >
              ANALYSE AVANCÉE EN COURS...
            </div>
            
            {/* Grille d'analyse */}
            <div 
              className="scan-grid" 
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundImage: 'linear-gradient(rgba(0, 200, 255, 0.15) 1px, transparent 1px), linear-gradient(90deg, rgba(0, 200, 255, 0.15) 1px, transparent 1px)',
                backgroundSize: '20px 20px',
                zIndex: 1,
                opacity: 0.5
              }}
            />
          </>
        )}
                            </div>

                            <Button
                              variant="danger"
                              size="sm"
                              className="position-absolute end-0 m-1"
                              onClick={() => {
                                setImagePreview(null);
                                setNewMealData({ ...newMealData, image: null });
                                setShowAnalyzeBtn(false);
                                setShowParcourirBtn(false);
                              }}
                            >
                              <i className="bi bi-x-lg"></i>
                            </Button>
                          </div>

                          {showAnalyzeBtn && (
                            <Button
                              className="mt-3"
                              variant="success"
                              onClick={() => {
                                setIsScanning(true);
                                setTimeout(() => {
                                  analyzeImageWithGemini(newMealData.image);
                                }, 1500);
                              }}
                              disabled={!newMealData.image || isScanning}
                            >
                              {isScanning ? (
                                <>
                                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                  Analyse en cours...
                                </>
                              ) : (
                                <>🔍 Analyser l'image</>
                              )}
                            </Button>
                          )}

                          {showParcourirBtn && (
                            <Button
                              className="mt-3 ms-2"
                              variant="primary"
                              onClick={() => document.getElementById('imageUpload')?.click()}
                            >
                              📁 Changer d'image
                            </Button>
                          )}
                        </Col>
                      )}

                      {/* Image choisie par l'IA */}
                      {aiImage && (
                        <Col md={imagePreview ? 6 : 8} className="text-center mb-3">
                          <div className="position-relative d-inline-block">
                            <Image
                              src={aiImage}
                              alt="Image IA"
                              fluid
                              rounded
                              style={{ maxHeight: '200px' }}
                            />
                          </div>
                          <div className="mt-2">
                            <Button
                              className="mt-3"
                              variant="warning"
                              onClick={() => setShowAnalysisModal(true)}
                            >
                              🔍 Choisir une autre suggestion
                            </Button>
                          </div>
                        </Col>
                      )}

                      {/* Affichage du bouton "Parcourir" si aucune image n'est présente */}
                      {!imagePreview && !aiImage && (
                        <Col md={6} className="text-center">
                          <i className="bi bi-cloud-upload display-4 text-muted mb-2 d-block"></i>
                          <p className="mb-2">Glissez-déposez une image ou</p>

                          <Form.Control
                            type="file"
                            accept="image/*"
                            onChange={handleImageChange}
                            className="d-none"
                            id="imageUpload"
                          />

                          <Button
                            variant="primary"
                            onClick={() => document.getElementById('imageUpload')?.click()}
                          >
                            📁 Parcourir
                          </Button>
                        </Col>
                      )}
                    </Row>
                  </div>
                </Form.Group>
              )}

              {/* <Form.Group className="mb-3">
                <Form.Label className="fw-bold">🥜 Allergènes ou interdits</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Ex: Gluten, Noix, Lactose"
                  value={newMealData.allergies}
                  onChange={(e) => setNewMealData({ ...newMealData, allergies: e.target.value })}
                />
                <Form.Text className="text-muted">
                  Séparer les allergènes par des virgules
                </Form.Text>
              </Form.Group> */}

              {/* Informations sur la recette actuelle */}
              <div className="bg-light p-3 rounded mb-3">
                <Row className="align-items-center">
                  <Col>
                    <small className="text-muted d-block">Repas actuel :</small>
                    <strong>{selectedMeal?.recipe?.recipeName || selectedMeal?.recipe?.name || "Aucun repas sélectionné"}</strong>
                    <div className="small text-muted mt-1">
                      {selectedMeal?.recipe?.description && (
                        <div>Description : {selectedMeal.recipe.description}</div>
                      )}
                      {selectedMeal?.recipe?.category && (
                        <div>Catégorie : {selectedMeal.recipe.category}</div>
                      )}
                    </div>
                  </Col>
                  <Col className="text-end">
                    <Badge bg="info" className="me-2">
                      {selectedMeal?.recipe?.totalNV?.calories || 0} kcal
                    </Badge>
                    <Badge bg="secondary">
                      {selectedMeal?.recipe?.difficulty || "Non spécifiée"}
                    </Badge>
                  </Col>
                </Row>
              </div>

              {/* Aperçu de la recette sélectionnée par IA */}
              {selectedRecipe && (
                <div className="bg-primary bg-opacity-10 p-3 rounded mb-3 border border-primary">
                  <h6 className="text-primary mb-2">
                    <i className="bi bi-robot me-2"></i>
                    Recette suggérée par IA :
                  </h6>
                  <div className="fw-bold">{selectedRecipe.title}</div>
                  <div className="small text-muted">{selectedRecipe.description}</div>
                  <div className="small mt-1">
                    <Badge bg="secondary" className="me-1">{selectedRecipe.difficulty}</Badge>
                    <Badge bg="info">{selectedRecipe.time}</Badge>
                  </div>
                </div>
              )}
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowChangeModal(false)}>
              Annuler
            </Button>
            <Button 
              variant="primary" 
              onClick={handleSubmitNewMeal}
              disabled={isUpdating || (!newMealData?.recipeName?.trim() && !selectedRecipe)}
            >
              {isUpdating ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Mise à jour...
                </>
              ) : (
                <>
                  <i className="bi bi-arrow-repeat me-2"></i>
                  Changer le plat
                </>
              )}
            </Button>
          </Modal.Footer>
        </Modal>
  
        {/* Modal détails du repas */}
        <Modal show={showMealDetails} onHide={() => setShowMealDetails(false)} centered size="lg">
          <Modal.Header closeButton>
            <Modal.Title>📋 Détails du repas</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedMeal && (
              <>
                <Row className="g-4">
                  <Col md={6}>
                    <Image 
                      src={selectedMeal.recipe?.imageUrl || RR34} 
                      alt={selectedMeal.recipe?.name}
                      fluid
                      rounded
                      className="w-100"
                      style={{ maxHeight: '300px', objectFit: 'cover' }}
                    />
                  </Col>
                  <Col md={6}>
                    <h3>{selectedMeal.recipe?.name}</h3>
                    <p className="text-muted">{selectedMeal.recipe?.description}</p>
                    
                    <div className="d-flex gap-3 mb-3">
                      <Badge bg="info">
                        <i className="bi bi-clock me-1"></i>
                        {selectedMeal.recipe?.preparationTime + (selectedMeal.recipe?.cookingTime || 0)} min
                      </Badge>
                      <Badge bg="secondary">
                        <i className="bi bi-speedometer2 me-1"></i>
                        {selectedMeal.recipe?.difficulty || "Non spécifiée"}
                      </Badge>
                      <Badge bg="primary">
                        <i className="bi bi-tag me-1"></i>
                        {selectedMeal.recipe?.category}
                      </Badge>
                    </div>
  
                    <Card className="mb-3">
                      <Card.Header>
                        <h5 className="mb-0">Valeurs nutritionnelles</h5>
                      </Card.Header>
                      <Card.Body>
                        <Row>
                          <Col xs={6}>
                            <div className="text-center p-2 border rounded">
                              <h6 className="mb-0">{selectedMeal.recipe?.totalNV?.calories || 0}</h6>
                              <small className="text-muted">Calories</small>
                            </div>
                          </Col>
                          <Col xs={6}>
                            <div className="text-center p-2 border rounded">
                              <h6 className="mb-0">{selectedMeal.recipe?.totalNV?.protein || 0}g</h6>
                              <small className="text-muted">Protéines</small>
                            </div>
                          </Col>
                          <Col xs={6} className="mt-2">
                            <div className="text-center p-2 border rounded">
                              <h6 className="mb-0">{selectedMeal.recipe?.totalNV?.carbs || 0}g</h6>
                              <small className="text-muted">Glucides</small>
                            </div>
                          </Col>
                          <Col xs={6} className="mt-2">
                            <div className="text-center p-2 border rounded">
                              <h6 className="mb-0">{selectedMeal.recipe?.totalNV?.fats || 0}g</h6>
                              <small className="text-muted">Lipides</small>
                            </div>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
  
                {selectedMeal.recipe?.ingredients && selectedMeal.recipe.ingredients.length > 0 && (
                  <div className="mt-4">
                    <h5>🥕 Ingrédients</h5>
                    <ListGroup className="mt-2">
                      {selectedMeal.recipe.ingredients.map((ingredient, index) => (
                        <ListGroup.Item key={index} className="d-flex justify-content-between align-items-center">
                          <span>{ingredient.food?.name}</span>
                          <span className="text-muted">{ingredient.quantity} {ingredient.unit || ''}</span>
                        </ListGroup.Item>
                      ))}
                    </ListGroup>
                  </div>
                )}
  
                {selectedMeal.recipe?.preparation && (
                  <div className="mt-4">
                    <h5>👨‍🍳 Préparation</h5>
                    <div className="bg-light p-3 rounded mt-2">
                      {selectedMeal.recipe.preparation}
                    </div>
                  </div>
                )}
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowMealDetails(false)}>
              Fermer
            </Button>
            {selectedMeal && !selectedMeal.consumed && (
              <Button 
                variant="primary" 
                onClick={() => {
                  setShowMealDetails(false);
                  openChangeModal(selectedMeal);
                }}
              >
                <i className="bi bi-arrow-repeat me-2"></i>
                Changer ce plat
              </Button>
            )}
          </Modal.Footer>
        </Modal>

        {/* Modal d'analyse d'image */}
        {showAnalysisModal && (
          <Modal 
            show={showAnalysisModal} 
            onHide={() => setShowAnalysisModal(false)}
            size="xl"
            scrollable
          >
            <Modal.Header closeButton className="bg-primary text-white">
              <Modal.Title>
                <i className="bi bi-camera-fill me-2"></i>
                Recettes suggérées d'après votre image
              </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: '80vh', overflowY: 'auto' }}>
              {parsedRecipes.length > 0 ? (
                <div className="row g-3">
                  {parsedRecipes.slice(0, 8).map((recipe) => (
                    <div className="col-md-3" key={recipe.id}>
                      <div 
                        className={`card h-95 ${selectedRecipe?.id === recipe.id ? 'border-primary border-3 shadow-lg' : 'border-light'}`}
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          setSelectedRecipe(recipe);
                          setAiImage(recipe.image);
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.classList.add('shadow');
                        }}
                        onMouseLeave={(e) => {
                          if (selectedRecipe?.id !== recipe.id) {
                            e.currentTarget.classList.remove('shadow');
                          }
                        }}
                      >
                        <div 
                          className="card-header bg-light d-flex align-items-center justify-content-center p-0"
                          style={{ height: '90px', overflow: 'hidden' }}
                        >
                          <img
                            src={recipe.image}
                            alt={recipe.title}
                            style={{
                              objectFit: 'cover',
                              width: '100%',
                              height: '100%'
                            }}
                          />
                        </div>

                        <div className="card-body d-flex flex-column">
                          <h5 className="card-title text-primary d-flex align-items-center">
                            {recipe.title}
                            {selectedRecipe?.id === recipe.id && (
                              <i className="bi bi-check-circle-fill text-success ms-auto"></i>
                            )}
                          </h5>
                          <p className="card-text text-muted small flex-grow-1">
                            {recipe.description}
                          </p>
                          <div className="d-flex justify-content-between align-items-center mb-0">
                            <div>
                              <span className="badge bg-secondary me-1">
                                <i className="bi bi-clock"></i> {recipe.time}
                              </span>
                              <span className="badge bg-info">
                                <i className="bi bi-star"></i> {recipe.difficulty}
                              </span>
                            </div>
                          </div>
                        </div>

                        {selectedRecipe?.id === recipe.id && (
                          <div className="card-footer bg-primary text-white text-center">
                            <small>
                              <i className="bi bi-hand-index"></i> Recette sélectionnée
                            </small>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-5">
                  <div className="alert alert-info">
                    <h5><i className="bi bi-info-circle"></i> Analyse de l'image</h5>
                    <div 
                      dangerouslySetInnerHTML={{
                        __html: analysisResult
                          .split('\n\n')
                          .map(paragraph => {
                            let html = paragraph
                              .replace(/\*\*\*(.*?)\*\*\*/g, '<strong><em>$1</em></strong>')
                              .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
                              .replace(/\*(.*?)\*/g, '<em>$1</em>');
                            return `<p class="mb-2">${html}</p>`;
                          })
                          .join('')
                      }}
                    />
                  </div>
                </div>
              )}

              {selectedRecipe && (
                <div className="mt-4" ref={detailsRef}>
                  <div className="card border-primary">
                    <div className="card-header bg-primary text-white">
                      <h4 className="mb-0">
                        <i className="bi bi-book"></i> Détails Recette sélectionnée : {selectedRecipe.title}
                      </h4>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <h5 className="text-secondary border-bottom pb-2">
                              <i className="bi bi-list-ul"></i> Ingrédients
                            </h5>
                            <div className="list-group list-group-flush">
                              {selectedRecipe.ingredients.map((ingredient, index) => (
                                <div key={index} className="list-group-item border-0 px-0">
                                  <i className="bi bi-chevron-right text-primary me-2"></i>
                                  {ingredient}
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <h5 className="text-secondary border-bottom pb-2">
                              <i className="bi bi-clipboard-check"></i> Instructions
                            </h5>
                            {selectedRecipe.instructions.length > 0 ? (
                              <div className="list-group list-group-numbered">
                                {selectedRecipe.instructions.map((step, index) => (
                                  <div key={index} className="list-group-item border-0 px-0">
                                    {step}
                                  </div>
                                ))}
                              </div>
                            ) : (
                              <div className="alert alert-light border">
                                <i className="bi bi-info-circle text-primary"></i>
                                <small className="ms-2">
                                  Instructions détaillées à préciser selon vos préférences.
                                </small>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </Modal.Body>

            <Modal.Footer className="bg-light">
              <div className="w-100 d-flex justify-content-between align-items-center">
                <Button 
                  variant="outline-secondary" 
                  onClick={() => setShowAnalysisModal(false)}
                >
                  <i className="bi bi-x-circle"></i> Fermer
                </Button>

                <div className="d-flex gap-2">
                  {selectedRecipe && (
                    <Button 
                      variant="success"
                      onClick={() => {
                        setNewMealData({
                          ...newMealData,
                          name: selectedRecipe.title,
                          description: selectedRecipe.description
                        });
                        setShowAnalysisModal(false);
                      }}
                    >
                      <i className="bi bi-plus-circle"></i> Choisir cette recette
                    </Button>
                  )}
                </div>
              </div>
            </Modal.Footer>
          </Modal>
        )}
      </div>
    </>
  );
  }
  export default DailyNutritionPlan;